import { ChangeDetectionStrategy, Component, DestroyRef, inject, ViewChild } from '@angular/core';
import { ListCustomCell } from '@shared/modules/list/interfaces/list-custom-cell.interface';
import { PermissionsGroups } from '@core/permissions/permissions.group';
import { debounceTime, tap } from 'rxjs/operators';
import { ListService } from '@shared/modules/list/services/list.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'project-client-cell',
  templateUrl: './project-client-cell.component.html',
  styles: [
    `
      .project-client-cell {
        width: 100%;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SharedModule]
})
export class ProjectClientCellComponent implements ListCustomCell {
  PermissionsGroups = PermissionsGroups;

  private service = inject(ListService);
  private destroyRef = inject(DestroyRef);

  @ViewChild('template') template;

  ngAfterViewInit() {
    setTimeout(() => {
      this.listenScrollTable();
    }, 1000);
  }

  listenScrollTable() {
    this.service.table.scroll
      .pipe(
        debounceTime(100),
        tap(() => {
          const popover = document.querySelector('mwl-confirmation-popover-window');
          if (popover) popover.remove();
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }
}
